export default __webpack_public_path__ + "static/media/cvod-R16.6d40691c.svg";